import { styled } from '../../../../../utils/styled';
import { propStyles } from '../../../../../utils/propStyles';
import ToastBase from './ToastBase';

const StyledComponent = styled<any, any>(
    ToastBase,
    'toastInfo',
    'feedback-toast'
)`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    backgroundColor: '#d1ecf1',
    color: '#0c5460',
    borderColor: '#bee5eb',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Toast/StyledComponents/ToastInfo.tsx